var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.components.scrollToTop.scrollToTop,{tag:"component",attrs:{"scrollPixelsToShow":_vm.config.scrollToTop.pixelsThreshold}},[_c(_vm.components.scrollToTop.icon,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }